import { store } from "../store/store";

export default function getToken() {
  const state = store.getState();
  return state.auth?.token;
}
